<template>
    <el-row v-if="UserLogin" id="nav-restaurant">
        <el-col :span="15">
            <img src="@/assets/icons/chevron.png" @click="goLandingPage" class="fs-nav-icon pointer" v-show="page == 'branch'">
            <img v-if="$i18n.locale == 'en'" @click="toggleLanguage('th')" class="fs-nav-icon pointer"  width="26" height="26" src="@/assets/icons/en_no_background.png"/>
            <img v-else @click="toggleLanguage('en')" class="fs-nav-icon pointer" width="26" height="26" src="@/assets/icons/th_no_background.png"/>
        </el-col>
        <el-col :span="3"><img src="@/assets/icons/search-w.png" @click="$emit('toggle_search')" class="fs-nav-icon pointer" v-show="page == 'branch'"></el-col>
        <el-col :span="3">
            <div class="fs-nav-icon">
                <img v-if="badge_editorder > 0" src="@/assets/icons/receipt-w-noti.png" @click="goComfirmOrder" class="pointer"  v-show="page == 'branch'">
                <img v-else src="@/assets/icons/receipt-w.png" @click="goComfirmOrder" class="pointer"  v-show="page == 'branch'">
            </div>
        </el-col>
        <el-col :span="3"><img src="@/assets/icons/profile-w.png" @click="goProfile" class="fs-nav-icon pointer" v-show="page == 'branch'"></el-col>
    </el-row>
    <el-row v-else id="nav-restaurant">
        <el-col :span="15">
            <img src="@/assets/icons/chevron.png" @click="goLandingPage" class="fs-nav-icon pointer" v-show="page == 'branch'">
            <img v-if="$i18n.locale == 'en'" @click="toggleLanguage('th')" class="fs-nav-icon pointer"  width="26" height="26" src="@/assets/icons/en_no_background.png"/>
            <img v-else @click="toggleLanguage('en')" class="fs-nav-icon pointer" width="26" height="26" src="@/assets/icons/th_no_background.png"/>
        </el-col>
        <el-col :span="3"></el-col>
        <el-col :span="3"><img src="@/assets/icons/search-w.png" @click="$emit('toggle_search')" class="fs-nav-icon pointer" v-show="page == 'branch'"></el-col>
        <el-col :span="3"><img src="@/assets/icons/profile-w.png" @click="redirectToLogin" class="fs-nav-icon pointer" v-show="page == 'branch'"></el-col>
    </el-row>
</template>

<script>
export default {
    data () {
        return {
            UserLogin: false
        }
    },
    props: {
        page: {
            default: ''
        },
        restaurant_uuid: {
            default: ''
        },
        branch_uuid: {
            default: ''
        },
        badge_editorder: {
            default: 0
        }
    },
    methods: {
        goProfile() {
            this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/profile` })
        },
        goComfirmOrder() {
            this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/order/history` })
        },
        goLandingPage () {
            this.$router.push({ path: `/restaurant/${this.restaurant_uuid}` })
        },
        redirectToLogin() {
            this.$router.push({ path: `/restaurant/${this.restaurant_uuid}/${this.branch_uuid}/verify/phonenumber` })
        },
        toggleLanguage (lang) {
            this.$store.dispatch('setLanguage', lang)
            return this.$store.dispatch('startLoading')
        }
    },
    mounted() {
        this.$store.dispatch('onAuthStateChanged').then((user) => {
            this.UserLogin = user
            if (user) {
                this.$store.dispatch('getUserInfo')
            }
        })
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/restaurant/RestaurantNav.vue